import React from 'react'
import Navbar from '../Navbar'

const Work = () => {
  return (
    <>
      <section className='hero'>
        <div className='container'>
          <div className="hh1 text-center" data-aos="fade-up" data-aos-delay="200">Page Under Development</div>
        </div>
      </section>
    </>
  )
}

export default Work
